// src/hooks/useAnnCostInvBySector.js
import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import { useMemo } from "react";

const ANN_COST_INV_SECTOR_QUERY = gql`
    query AnnCostInvSector($scenario: String, $sectors: [String!]) {
    timeSeries(view: EDRC_ANN_COST_INV, scenario: $scenario, sectors: $sectors) {
        scenario
        year
        group
        value
    }
    }
`;

export function useAnnCostInvBySector({ scenario, sectors, from, to } = {}) {
const { data, loading, error } = useQuery(ANN_COST_INV_SECTOR_QUERY, {
  variables: {
    scenario,
    // pass only if you actually have a list; otherwise omit it
    sectors: Array.isArray(sectors) ? sectors.filter(Boolean) : undefined,
  },
  fetchPolicy: "cache-first",
});



  const labels = useMemo(() => {
    const years = new Set();
    for (const r of data?.timeSeries ?? []) {
      if (typeof r.year !== "number") continue;
      if (from && r.year < from) continue;
      if (to && r.year > to) continue;
      years.add(r.year);
    }
    return Array.from(years).sort((a, b) => a - b).map(String);
  }, [data, from, to]);

  const bySectorYear = useMemo(() => {
    const map = {};
    for (const r of data?.timeSeries ?? []) {
      if (from && r.year < from) continue;
      if (to && r.year > to) continue;
      const code = r.group || "OTH";
      if (!map[code]) map[code] = {};
      map[code][r.year] = (map[code][r.year] || 0) + (typeof r.value === "number" ? r.value : 0);
    }
    return map;
  }, [data, from, to]);

  const sectorsFound = useMemo(() => Object.keys(bySectorYear).sort(), [bySectorYear]);

  return { labels, bySectorYear, sectors: sectorsFound, loading, error };
}
